import { useLocation } from 'react-router-dom';
import "./dashboard.css";
import RecentTestTaken from "../../components/RecentTestTaken/RecentTestTaken"
import InterviewTable from "../../components/InterviewTable/InterviewTable"
import RecentActivite from "../../components/RecentActivite/RecentActivite"
import UpcomingStart from "../../components/UpcomingStart/UpcomingStart"
import RequisitionsOverview from '../../components/RequisitionsOverview/RequisitionsOverview';
import UnauthorizedAccess from '../../components/UnauthorizedAccess/UnauthorizedAccess';

function Dashboard(props) {
    
    const location = useLocation();
    const state = location?.state || {};
    const idContextTest = state.id ?? props?.id;
    const userRole = state.roleName ?? props?.userType;
    const userRecruitmentpartnerId = state.recruitmentPartnerId ?? props?.userRecruitmentpartnerId;
    const userRecords = state.userRecords ?? props?.userRecords;
    const userType = props?.userType;

    return (
        <>
            {((userType === "Recruiter") || (userType === "Admin") || (userType === "Recruitment Leader") || (userType === "MIS Operator") || (userType === "Organization Admin") || (userType === "Team Leader")) ?
                <>
                    <div className="bento-container">
                        {/* Top Stats Block */}
                        <RequisitionsOverview
                            idContextTest={idContextTest}
                            userRole={userRole}
                            userRecruitmentpartnerId={userRecruitmentpartnerId}
                            userRecords={userRecords}
                            userType={userType}
                        />


                        {/* Recent Tests */}
                        <RecentTestTaken
                            idContextTest={idContextTest}
                            userRole={userRole}
                            userRecruitmentpartnerId={userRecruitmentpartnerId}
                            userRecords={userRecords}
                            userType={userType}

                        />

                        {/* Interview View */}
                        <InterviewTable
                            idContextTest={idContextTest}
                            userRole={userRole}
                            userRecruitmentpartnerId={userRecruitmentpartnerId}
                            userRecords={userRecords}
                            userType={userType}
                        />



                        {/* Upcoming Starts */}
                        <UpcomingStart
                            idContextTest={idContextTest}
                            userRole={userRole}
                            userRecruitmentpartnerId={userRecruitmentpartnerId}
                            userRecords={userRecords}
                            userType={userType}
                        />

                        {/* Recent Activities */}
                        <RecentActivite
                            idContextTest={idContextTest}
                            userType={userType}
                            userRole={userRole}
                            userRecruitmentpartnerId={userRecruitmentpartnerId}
                            userRecords={userRecords}
                        />
                    </div>
                </>
                : (
                    <UnauthorizedAccess />
                )}
        </>
    );
}

export default Dashboard